module.exports = __webpack_public_path__ + "img/daneshbonyan.2399238.png";